module.exports = __webpack_public_path__ + "media/images/logo_sm-747e80f9.png";